import { ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi
} from '@angular/common/http';
import { provideClientHydration, withEventReplay, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { GlobalErrorHandlerService } from '@lib.core/logger/global-error-handler.service';
import { CHART_APP_VERSION } from '@lib.publications/chart-engine/chart/chart-app-version';
import { provideDownloads } from '@lib.publications/content-actions/download-interactor';
import { SHARE_OFFERED } from '@lib.publications/content-actions/share-offered';
import { routes } from '@public/src/app/app.routes';
import { version } from '@public/src/app/version';
import { environment } from '@public/src/environments/environment';

const matomoProviders = environment.matomo.enabled ?
  [
    provideMatomo(
      {
        trackerUrl: environment.matomo.trackerUrl,
        siteId: environment.matomo.siteId,
        scriptUrl: environment.matomo.scriptUrl,
        enableLinkTracking: true,
        requireConsent: 'none',
        acceptDoNotTrack: false,
        runOutsideAngularZone: true
      },
      withRouter()
    )] : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    })),
    provideClientHydration(withEventReplay(), withNoIncrementalHydration()),
    provideHttpClient(
      withInterceptorsFromDi(),
      withFetch()
    ),
    provideTranslateService({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader()
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    ...matomoProviders,
    provideDownloads(),
    { provide: SHARE_OFFERED, useValue: false },
    { provide: CHART_APP_VERSION, useValue: version },
  ]
};
